import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import GCKCodeService from './GCKCode.service'

export const useGCKCode = () => {
  const service = new GCKCodeService()
  const baseCrud = useCrud(API_RESOURCE.GCK_CODE, service)

  const queryClient = useQueryClient()

  const useUploadGCKCodes = () => {
    return useMutation({
      mutationFn: service.uploadGCKCode,
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.GCK_CODE)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useGCKCodeOptions = (parameter = {}) => {
    const {
      status = 'active',
      labelKey = 'description',
      valueKey = 'description',
      withNilOptions = false,
      ...rest
    } = parameter
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status, ...rest } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status, ...rest } }),
      placeholderData: keepPreviousData,
      select: (data) => createOptions(data?.data, labelKey, valueKey, withNilOptions),
    })
  }

  return {
    //Base CRUD
    useFetchAllGCKCodes: baseCrud.useFetchAll,
    useFetchGCKCode: baseCrud.useFetchOne,
    useCreateGCKCode: baseCrud.useCreate,
    useUpdateGCKCode: baseCrud.useUpdate,
    useRemoveGCKCode: baseCrud.useRemove,

    //Extra
    useUploadGCKCodes,
    useGCKCodeOptions,
  }
}
